import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.71967 5.46967C2.01256 5.17678 2.48744 5.17678 2.78033 5.46967L9 11.6893L12.7557 7.93367C13.0211 7.66825 13.4418 7.63992 13.7404 7.86736C15.9817 9.57447 17.5917 11.9785 18.3167 14.701L18.624 15.8486L20.9005 11.906C21.1076 11.5473 21.5663 11.4244 21.925 11.6315C22.2837 11.8386 22.4066 12.2973 22.1995 12.656L19.0175 18.167C18.918 18.3393 18.7542 18.465 18.5621 18.5164C18.37 18.5679 18.1652 18.541 17.993 18.4415L12.482 15.2595C12.1233 15.0524 12.0004 14.5937 12.2075 14.235C12.4146 13.8763 12.8733 13.7534 13.232 13.9605L17.1753 16.2373L16.8673 15.087C16.284 12.897 15.0515 10.9407 13.3393 9.47132L9.53033 13.2803C9.23744 13.5732 8.76256 13.5732 8.46967 13.2803L1.71967 6.53033C1.42678 6.23744 1.42678 5.76256 1.71967 5.46967Z"
        fill={colorValue}
      />
    </svg>
  );
};
